// Copied from pipecat_bot.py::_stt_keyterm_candidates. A parity test prevents
// drift; preserve voice-call vocabulary order and the realtime 50/20 limits.
const voiceCallKeyterms = [
  "Lexius",
  "habeas corpus",
  "habeas data",
  "in dubio pro reo",
  "pro actione",
  "erga omnes",
  "inter partes",
  "ratio decidendi",
  "obiter dicta",
  "mutatis mutandis",
  "prima facie",
  "ex officio",
  "ipso iure",
  "ipso facto",
  "iuris tantum",
  "jurisprudencia",
  "novación",
  "prescripción",
  "adquisitiva",
  "amparo",
  "tutela",
  "casación",
  "apelación",
  "impugnación",
  "exhorto",
  "usufructo",
  "servidumbre",
  "arbitraje",
  "conciliación",
  "otrosí",
  "nulidad",
  "caducidad",
  "preclusión",
  "contencioso",
  "fiscalía",
  "allanamiento",
  "cosa juzgada",
  "debido proceso",
  "inconstitucional",
  "Ministerio Público",
  "artículo",
  "inciso",
  "sentencia"
];
// Mirrors country_constants.py::get_capitalized_country for supported tenants.
const countryNames = {
  venezuela: 'Venezuela', colombia: 'Colombia', chile: 'Chile', peru: 'Perú',
  ecuador: 'Ecuador', paraguay: 'Paraguay', uruguay: 'Uruguay', bolivia: 'Bolivia',
  argentina: 'Argentina', panama: 'Panamá', mexico: 'México', 'costa rica': 'Costa Rica',
  'el salvador': 'El Salvador', 'republica dominicana': 'República Dominicana',
  honduras: 'Honduras', 'puerto rico': 'Puerto Rico', guatemala: 'Guatemala',
  cuba: 'Cuba', nicaragua: 'Nicaragua',
};

/** Supply only the nearby draft prefix and a small, tenant-specific vocabulary. */
export function buildRecognitionContext(text, selectionEnd, country) {
  const draft = String(text || '');
  const end = Number.isFinite(selectionEnd) ? Math.max(0, Math.min(draft.length, selectionEnd)) : draft.length;
  const prefix = Array.from(draft.slice(0, end).replace(/\s+/g, ' ').trim());
  let suffix = prefix.slice(-49).join('');
  if (prefix.length > 49 && !/\s/.test(prefix[prefix.length - 50]) && !/^\s/.test(suffix)) {
    // Drop a truncated opening word when another word remains in the window.
    const boundary = suffix.indexOf(' ');
    if (boundary !== -1) suffix = suffix.slice(boundary + 1);
  }
  const slug = String(country || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  const displayCountry = Object.hasOwn(countryNames, slug) ? countryNames[slug] : null;
  const vocabulary = [...voiceCallKeyterms];
  if (displayCountry) vocabulary.push(displayCountry);
  return {
    previousText: suffix.trim() || 'Consulta jurídica en español.',
    keyterms: vocabulary.filter(term => Array.from(term).length <= 20).slice(0, 50),
  };
}
